

export enum CORE_EDITOR_META {
  SKIP_FILE_DELETION = "skipFileDeletion",
  INTENTIONAL_DELETION = "intentionalDeletion",
  ADD_TO_HISTORY = "addToHistory",
}
